import { render, staticRenderFns } from "./temperatureAndHumidity.vue?vue&type=template&id=27c246a8&scoped=true"
import script from "./temperatureAndHumidity.vue?vue&type=script&lang=js"
export * from "./temperatureAndHumidity.vue?vue&type=script&lang=js"
import style0 from "./temperatureAndHumidity.vue?vue&type=style&index=0&id=27c246a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c246a8",
  null
  
)

export default component.exports